/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum BlockRuleSelectorAttributePredicate {
  EQUALS = 0,
  EXISTS = 1,
  CONTAINS = 2,
  STARTS_WITH = 3,
  ENDS_WITH = 4,
  CONTAINS_WS_TOKEN = 5,
  CONTAINS_HYPHEN_TOKEN = 6,
}
